import VisualizeTerm from '../components/course/visualize-term';
<template><VisualizeTerm @model={{@model}} /></template>
